import { render, staticRenderFns } from "./gButton.vue?vue&type=template&id=11cebd32&scoped=true&"
import script from "./gButton.vue?vue&type=script&lang=js&"
export * from "./gButton.vue?vue&type=script&lang=js&"
import style0 from "./gButton.vue?vue&type=style&index=0&id=11cebd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cebd32",
  null
  
)

export default component.exports